module.exports = __webpack_public_path__ + "static/media/sad.0e852e4d.svg";